export default __webpack_public_path__ + "static/media/consoleLogo.7f0d2ac6.svg";